import { render, staticRenderFns } from "./SinglechoiceModule.vue?vue&type=template&id=3c87dd80&scoped=true&"
import script from "./SinglechoiceModule.vue?vue&type=script&lang=js&"
export * from "./SinglechoiceModule.vue?vue&type=script&lang=js&"
import style0 from "./SinglechoiceModule.vue?vue&type=style&index=0&id=3c87dd80&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c87dd80",
  null
  
)

export default component.exports